import { useEffect, useState } from "react";
import { DeviceMobile, Export, PlusSquare, X } from "@phosphor-icons/react";

const KEY = "yljm_install_dismissed";
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const InstallAppCard = () => {
  const [prompt, setPrompt] = useState(null);
  const [hidden, setHidden] = useState(() => isStandalone() || localStorage.getItem(KEY) === "1");
  const [showIOS, setShowIOS] = useState(false);
  const ios = isIOS();

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => setHidden(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (hidden || (!prompt && !ios)) return null;

  const dismiss = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  const install = async () => {
    if (ios) return setShowIOS(true);
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setHidden(true);
    setPrompt(null);
  };

  return (
    <div data-testid="install-app-card" className="relative mb-8 flex flex-col gap-4 rounded-2xl sm:flex-row sm:items-center border border-[#B08D57]/30 bg-white p-5 pr-12 shadow-sm">
      <div className="flex min-w-0 flex-1 items-start gap-4">
      <DeviceMobile size={32} weight="duotone" className="shrink-0 text-[#E06D53]" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-[#2C2A28]">Add Your Life Journey to your home screen</p>
        <p className="text-sm text-[#4A4540]">Open your diary in one tap, just like a regular app.</p>
        {showIOS && (
          <ol data-testid="install-ios-steps" className="mt-3 space-y-1.5 text-sm text-[#2C2A28]">
            <li>1. Tap <Export size={18} className="inline align-text-bottom text-[#36858B]" /> <b>Share</b> in Safari</li>
            <li>2. Choose <PlusSquare size={18} className="inline align-text-bottom text-[#36858B]" /> <b>Add to Home Screen</b></li>
            <li>3. Tap <b>Add</b></li>
          </ol>
        )}
      </div>
      </div>
      {!showIOS && (
        <button data-testid="install-app-btn" onClick={install}
          className="w-full rounded-full bg-[#E06D53] px-6 py-3 sm:w-auto text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[#C95A42]">
          Install app
        </button>
      )}
      <button data-testid="install-app-dismiss" onClick={dismiss} aria-label="Dismiss"
        className="absolute right-2 top-2 flex h-11 w-11 items-center justify-center rounded-full text-[#4A4540] hover:bg-[#F4EFE6]">
        <X size={18} />
      </button>
    </div>
  );
};
